// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vHHk","col":"styles_col__1ts94"};